import { constants } from '@bedc/constants';

import { Request } from '../../../../api/fpc/search/Request';

import { SearchDataTableType } from './SearchDataTableType';

export const FPCType = SearchDataTableType({
	request: Request,
	columnFields: constants.fpc.opensearch.columnFields,
	filterIds: constants.fpc.opensearch.filterFields,
});
